import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { completedProjectsService } from '../../../services/CompletedProjectsService';
import ReactPaginate from 'react-paginate';

class AdminCompletedProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newCompletedProject: {
        title: '',
        description: '',
        value: 0,
        start_date: '',
        end_date: '',
        document: ''
      },
      existingProjects: [],
      deleteProject: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    completedProjectsService
      .getAll()
      .then(jsonResponse => {
        this.setCompletedProjectsState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    completedProjectsService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setCompletedProjectsState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setCompletedProjectsState = response => {
    let existingProjects = { ...this.state.existingProjects };
    let pagination = { ...this.state.pagination };
    existingProjects = response.completed_projects;
    pagination = response.pagination;

    this.setState({ existingProjects });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newCompletedProject = this.state.newCompletedProject;
    newCompletedProject[field] = event.target.value;

    this.setState({
      newCompletedProject
    });
  };

  onDropDocument = documents => {
    let newCompletedProject = { ...this.state.newCompletedProject };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newCompletedProject.document = documents[0];

      self.setState({ newCompletedProject });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newCompletedProject = { ...this.state.newCompletedProject };
    newCompletedProject.document = null;

    this.setState({ newCompletedProject });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newCompletedProject = { ...this.state.newCompletedProject };
    newCompletedProject = {
      title: '',
      description: '',
      value: 0,
      start_date: '',
      end_date: '',
      document: ''
    };

    this.setState({ newCompletedProject });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newCompletedProject.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/completed_projects/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/completed_projects/${this.state.newCompletedProject.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingProjects = this.state.existingProjects.slice();

        let index = existingProjects.findIndex(
          existingProject => existingProject.id === jsonResponse.id
        );

        if (index !== -1) {
          existingProjects[index] = jsonResponse;
        } else {
          existingProjects.push(jsonResponse);
        }

        this.setState({ existingProjects });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Proiectul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Proiectul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'completed_project[title]',
      this.state.newCompletedProject.title
    );
    formData.append(
      'completed_project[description]',
      this.state.newCompletedProject.description
    );
    formData.append(
      'completed_project[value]',
      this.state.newCompletedProject.value
    );
    formData.append(
      'completed_project[start_date]',
      this.state.newCompletedProject.start_date
    );
    formData.append(
      'completed_project[end_date]',
      this.state.newCompletedProject.end_date
    );

    if (this.state.newCompletedProject.document) {
      let document = this.state.newCompletedProject.document;
      appendAttachment(formData, `completed_project[document]`, document);
    }

    return formData;
  }

  setCertificateForEdit = newProject => {
    let newCompletedProject = { ...this.state.newCompletedProject };
    newCompletedProject = Object.assign({}, newProject);
    this.setState({ newCompletedProject });

    if (newProject.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteProject = { ...this.state.deleteProject };
    deleteProject = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteProject });
  };

  closeDeleteDialog = () => {
    let deleteProject = { ...this.state.deleteProject };
    deleteProject = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteProject });
  };

  handleDelete = () => {
    completedProjectsService
      .deleteCompletedProject(this.state.deleteProject.deleteId)
      .then(() => {
        let existingProjects = this.state.existingProjects.slice();
        existingProjects = existingProjects.filter(
          project => project.id !== this.state.deleteProject.deleteId
        );
        this.setState({ existingProjects });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Proiectul a fost stears cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title">
            Proiecte finalizate
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">
                  Adauga un proiect finalizat
                </h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu proiect*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newCompletedProject.title}
                  />

                  <h4 className="label-title label-title-provisions">
                    Descriere proiect*
                  </h4>
                  <textarea
                    required
                    rows="5"
                    className="general-field title-field"
                    type="text"
                    name="description"
                    onChange={this.updateField}
                    value={this.state.newCompletedProject.description}
                  />

                  <h4 className="label-title label-title-provisions">
                    Valoare proiect (valoarea este reprezentata in RON)*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="number"
                    name="value"
                    onChange={this.updateField}
                    value={this.state.newCompletedProject.value}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată inceput*
                  </h4>
                  <input
                    required
                    className="general-field date-field"
                    type="date"
                    name="start_date"
                    onChange={this.updateField}
                    value={this.state.newCompletedProject.start_date}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată finalizat*
                  </h4>
                  <input
                    required
                    className="general-field date-field"
                    type="date"
                    name="end_date"
                    onChange={this.updateField}
                    value={this.state.newCompletedProject.end_date}
                  />
                </div>

                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Documente proiect:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newCompletedProject.document}
                    documentFilename={
                      this.state.newCompletedProject.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newCompletedProject.id
                        ? 'Editează Proiect'
                        : 'Adaugă Proiect'}
                    </button>
                  </div>
                  {Object.values(this.state.newCompletedProject) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingProjects.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Proiecte finalizate existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingProjects.map(project => (
                      <div
                        className="existing-items__content-card"
                        key={project.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {project.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() => this.setCertificateForEdit(project)}
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() => this.openDeleteDialog(project.id)}
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteProject.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest proiect?"
                    aditionalText="Dupa stergere, proiectul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminCompletedProjects;
